module.exports = __webpack_public_path__ + "static/img/DAMIEN_FLEMING.5aa8614.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DAMIEN_FLEMING.jpg
// module id = sHHW
// module chunks = 0